module.exports = __webpack_public_path__ + "static/media/Appointment-duration.03987e47.svg";